import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { ClosingCoordinatorStore } from "../store/closingCoordinatorStore";

export const useClosingCoordinatorStore = () =>
  useContext<{ closingCoordinatorStore: ClosingCoordinatorStore; }>(StoreContext);
